module.exports = __webpack_public_path__ + "static/SGRed-06b00998107d99cf3cffa5438c4bc2eb.png";